import { deletePersonalList } from '../../services';

export async function deletePersonalLineup(id: number): Promise<void> {
  await deletePersonalList({ personalListId: id });
}
